var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M16 3a6 6 0 1 1-.971 11.921l-.848.846 2.426 2.425a1 1 0 0 1 .083 1.32l-.083.095a1 1 0 0 1-1.32.083l-.095-.083-2.208-2.21a5 5 0 1 1-5.383-5.381L5.293 9.707a1 1 0 0 1 1.32-1.497l.094.083 2.525 2.524.847-.846A6 6 0 0 1 16 3zM8 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm8-9a4 4 0 0 0-3.684 5.562l-1.644 1.645 2.12 2.121 1.646-1.644A4 4 0 1 0 16 5z" })
  );
});